import React from 'react';
import { Link } from 'react-router-dom';
import './QuickActions.css';

const ACTIONS = [
  {
    label: 'Create Test Case',
    link: '/test-cases',
    icon: <path d="M9 11l3 3L22 4M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/>,
  },
  {
    label: 'Create Scenario',
    link: '/test-scenarios',
    icon: <><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></>,
  },
  {
    label: 'Generate with AI',
    link: '/test-scenarios',
    icon: <path d="M12 2l1.9 5.8L20 10l-6.1 2.2L12 18l-1.9-5.8L4 10l6.1-2.2L12 2z"/>,
    accent: 'purple' as const,
  },
  {
    label: 'Create Test Run',
    link: '/test-runs/create',
    icon: <><circle cx="12" cy="12" r="10"/><polygon points="10 8 16 12 10 16 10 8"/></>,
  },
];

export const QuickActions: React.FC = () => (
  <div className="qa-row">
    {ACTIONS.map(a => (
      <Link key={a.label} to={a.link} className={`qa-btn${a.accent ? ` qa-btn-${a.accent}` : ''}`}>
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">{a.icon}</svg>
        {a.label}
      </Link>
    ))}
    <Link to="/reports" className="qa-btn qa-btn-ghost">
      View Reports
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>
    </Link>
  </div>
);

export default QuickActions;
